import Vue from 'vue'
import VueRouter, { RouteConfig } from 'vue-router'
import { Dictionary } from 'vue-router/types/router'
import Home from './views/Home.vue'

export enum QueryParameters {
  MapBounds = 'map-bounds',
  EventSearchPhrase = 'event-search-phrase',
  TagSearchPhrase = 'tag-search-phrase',
  SelectedEventIdentifier = 'selected-event-identifier',
  SelectedTagIdentifier = 'selected-tag-identifier',
  SelectedPlaceIdentifier = 'selected-place-identifier',
  Banner = 'banner',
  ScheduleTags = 'schedule-tags',
  ScheduleDatetimeFrom = 'schedule-datetime-from',
  ScheduleDatetimeTo = 'schedule-datetime-to',
  ScheduleRadiusKm = 'schedule-radius-km',
  ScheduleShowAll = 'schedule-show-all'
}

export class Router extends VueRouter {
  setQueryParameters (queryParameters: Dictionary<string | (string | null)[] | null | undefined>, addHistoryEntry?: boolean) {
    const query: Dictionary<string | (string | null)[]> = { ...this.currentRoute.query } as any
    Object.keys(queryParameters).forEach(key => {
      const value = queryParameters[key]
      if (value === undefined || value === null || value === '') {
        delete query[key]
      } else {
        query[key] = value as any
      }
    })
    // Avoid .call() — TS picks the void (callback) overload and loses Promise.
    const navigation = addHistoryEntry ? this.push({ query }) : this.replace({ query })
    Promise.resolve(navigation).catch(() => {})
  }

  setQueryParameter (key: string, value: undefined | null | string | (null | string)[], addHistoryEntry?: boolean) {
    this.setQueryParameters({ [key]: value }, addHistoryEntry)
  }

  removeQueryParameter (key: string, addHistoryEntry?: boolean) {
    this.setQueryParameter(key, undefined, addHistoryEntry)
  }
}

Vue.use(Router)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
    {
    path: '/:alias',
    name: 'Alias',
    component: Home
  }
  // {
  //   path: '/about',
  //   name: 'About',
  //   // Route level code-splitting:
  //   // this generates a separate chunk ("about.[hash].js") for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

export default new Router({
  mode: 'history',
  base: '', // process.env.BASE_URL
  routes
})
